import React from 'react';
import AddScrollHeight from '../../components/AddScrollHeight';
import Services from '../../services/Services';
import PickTime from '../../times/PickTime';

const DynamicServices = props => (
  <div>
    <Services {...props} />
    <AddScrollHeight>
      <div className="c-second-layer">
        <PickTime {...props} autoHeight from="service" />
      </div>
    </AddScrollHeight>
  </div>
);

export default DynamicServices;



// WEBPACK FOOTER //
// ./src/app/dynamicBooking/barber/Services.jsx